export default __webpack_public_path__ + "static/media/cif-ls.5a557c8f.svg";